import * as React from "react";
import { Select, Option } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";

interface FormActionSelectProps {
    name: string;
    disabled?: boolean;
    [key: string]: any;
}

export default function FormActionSelect({
    name,
    disabled,
    ...props
}: FormActionSelectProps) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Select
                    {...field}
                    size="md"
                    disabled={disabled}
                    onChange={(_, newValue) => field.onChange(newValue)}
                    placeholder="Action"
                    {...props}
                    sx={{
                        bgcolor: "background.surface",
                        borderRadius: "4px",
                        boxShadow: "none",
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        ...props.sx,
                    }}
                >
                    <Option value="Replace">R&R</Option>
                    <Option value="Install">Inst</Option>
                    <Option value="None">None</Option>
                    <Option value="Detach & Reset">D&R</Option>
                </Select>
            )}
        />
    );
}
